const state = {
  orgData: {}
}

const actions = {
  async getCurrentOrgData({ commit, rootState, state }) {
    let userInfo = rootState.app.account.userInfo || {}
    if (Object.keys(state.orgData).length == 0) {
      let result = await TdUI.api.admin.org.getDeptDetail(userInfo.unitId)
      if (result.code == 200) {
        state.orgData = result.data
      }
    }
    return state.orgData
  }
}
const mutations = {
  setOrgData(state, orgData) {
    state.orgData = orgData
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
